import { render, staticRenderFns } from "./platformSettlementFundDetail.vue?vue&type=template&id=c80e7a4c&scoped=true"
import script from "./platformSettlementFundDetail.vue?vue&type=script&lang=js"
export * from "./platformSettlementFundDetail.vue?vue&type=script&lang=js"
import style0 from "./platformSettlementFundDetail.vue?vue&type=style&index=0&id=c80e7a4c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80e7a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80e7a4c')) {
      api.createRecord('c80e7a4c', component.options)
    } else {
      api.reload('c80e7a4c', component.options)
    }
    module.hot.accept("./platformSettlementFundDetail.vue?vue&type=template&id=c80e7a4c&scoped=true", function () {
      api.rerender('c80e7a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/financeManagement/platformSettlementFund/platformSettlementFundDetail.vue"
export default component.exports